import React, { forwardRef, useMemo } from 'react'
import RsSelect, { components as RsComponents } from 'react-select'
import { useTheme } from '@mui/material'
import MenuList, { MultiMenuList } from './components/MenuList'
import DropdownIndicator from './components/DropdownIndicator'
import ValueContainer, { MultiValueContainer } from './components/ValueContainer'
import Control from './components/Control'
import { OptionMulti, OptionSingle } from './components/Option'
import styles from './styles'

const Select = forwardRef(
  (
    {
      value,
      onChange,
      mainField = 'name',
      keyField = 'id',
      isMulti,
      width,
      height,
      defaultPlaceholder,
      selectedPlaceholder,
      noOptionsMessage,
      hideSelectedOptions = false,
      components,
      ...props
    },
    ref,
  ) => {
    const theme = useTheme()
    const placeholder = useMemo(() => {
      if (value) {
        if (isMulti && value.length > 0) {
          return `${value.length} ${selectedPlaceholder}`;
        }
        if (!isMulti && Object.keys(value).length > 0) {
          return value[mainField];
        }
      }
      return defaultPlaceholder;
    }, [value, selectedPlaceholder, defaultPlaceholder]);

    return (
      <RsSelect
        ref={ref}
        value={value}
        onChange={onChange}
        noOptionsMessage={() => noOptionsMessage || 'No results'}
        components={{
          ...RsComponents,
          Control,
          MenuList: isMulti ? MultiMenuList : MenuList,
          DropdownIndicator,
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
          Option: isMulti ? OptionMulti : OptionSingle,
          ValueContainer: isMulti ? MultiValueContainer : ValueContainer,
          ...components
        }}
        mainField={mainField}
        keyField={keyField}
        isLoading={false}
        isSearchable={false}
        hideSelectedOptions={hideSelectedOptions}
        isMulti={isMulti}
        placeholder={placeholder}
        getOptionLabel={(option) => option[mainField]}
        getOptionValue={(option) => option[keyField]}
        styles={styles({...props, theme, width, height, keyField})}
        {...props}
      />
    );
  },
);

export default Select;